import React, { useEffect, useState } from "react";
import { BASEAPIURL, token } from "../env";
import News from "./News";

const CircularNotice = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotices();
  }, []);

  const fetchNotices = async () => {
    setLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({ tokenData: token });

      const response = await fetch(`${BASEAPIURL}/NotificationList`, {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      });

      const result = await response.json();

      if (result.status && Array.isArray(result.data)) {
        setNotices(result.data);
      } else {
        console.error("Invalid response:", result);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <News className="pb-4"/>

      {loading ? (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : notices.length > 0 ? (
        <div className="row">
          {notices.map((notice, index) => (
            <div className="col-md-4 mb-4" key={notice.SNo || index}>
              <div className="card h-100 shadow-sm">
                {notice.NotiImages && (
                  <img
                    src={notice.NotiImages}
                    alt={`Notice ${index}`}
                    className="card-img-top"
                    style={{ objectFit: "cover", height: "200px" }}
                  />
                )}
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title text-primary">{notice.NotiTitle}</h5>
                  <p className="card-text">{notice.NotiDesc}</p>
                  <p className="card-text text-muted mt-auto" style={{ fontSize: '0.9em' }}>
                    <strong>Start:</strong> {notice.NotiFromDate ? notice.NotiFromDate.split("T")[0] : "-"}<br />
                    <strong>End:</strong> {notice.NotiToDate ? notice.NotiToDate.split("T")[0] : "-"}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center">No notices available</p>
      )}
    </div>
  );
};

export default CircularNotice;
